
(function () {
  "use strict";

  const TIMEZONE = "Europe/Amsterdam";
  const SELECTOR = '[data-custom-delivery="true"]';

  function getLocalParts(now) {
    const formatter = new Intl.DateTimeFormat("en-GB", {
      timeZone: TIMEZONE,
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      hourCycle: "h23"
    });

    const parts = {};

    formatter.formatToParts(now).forEach(function (part) {
      if (part.type !== "literal") {
        parts[part.type] = Number(part.value);
      }
    });

    return parts;
  }

  function makeDate(parts) {
    const date = new Date(0);

    date.setUTCFullYear(
      parts.year,
      parts.month - 1,
      parts.day
    );

    date.setUTCHours(12, 0, 0, 0);

    return date;
  }

  function addDays(date, days) {
    const result = new Date(date.getTime());
    result.setUTCDate(result.getUTCDate() + days);
    return result;
  }

  function formatDate(date) {
    return new Intl.DateTimeFormat("en-GB", {
      timeZone: "UTC",
      day: "numeric",
      month: "long"
    }).format(date);
  }

  function formatDayAndDate(date) {
    return new Intl.DateTimeFormat("en-GB", {
      timeZone: "UTC",
      weekday: "long",
      day: "numeric",
      month: "long"
    }).format(date);
  }

  function formatWeekday(date) {
    return new Intl.DateTimeFormat("en-GB", {
      timeZone: "UTC",
      weekday: "long"
    }).format(date);
  }

  function calculateMessage(now, cutoff) {
    const parts = getLocalParts(now);
    const today = makeDate(parts);

    // Sunday = 0, Monday = 1, ..., Saturday = 6
    const day = today.getUTCDay();
    const beforeCutoff = parts.hour < cutoff;
    const cutoffLabel =
      String(cutoff).padStart(2, "0") + ":00";

    let deliveryDate;

    // Monday–Thursday before cutoff
    if (day >= 1 && day <= 4 && beforeCutoff) {
      deliveryDate = addDays(today, 1);

      return (
        "Order before " + cutoffLabel +
        " for delivery tomorrow (" +
        formatDayAndDate(deliveryDate) + ")"
      );
    }

    // Friday before cutoff
    if (day === 5 && beforeCutoff) {
      deliveryDate = addDays(today, 3);

      return (
        "Order before " + cutoffLabel +
        " for delivery on Monday (" +
        formatDate(deliveryDate) + ")"
      );
    }

    // Monday–Thursday at/after cutoff
    if (day >= 1 && day <= 4) {
      deliveryDate = addDays(today, 2);

      return (
        "Order now for delivery on " +
        formatWeekday(deliveryDate) +
        " (" + formatDate(deliveryDate) + ")"
      );
    }

    // Friday at/after cutoff, Saturday and Sunday
    deliveryDate = addDays(today, (9 - day) % 7);

    return (
      "Order now for delivery on Tuesday (" +
      formatDate(deliveryDate) + ")"
    );
  }

  function updateBlock(block, now = new Date()) {
    const output = block.querySelector(
      "[data-delivery-output]"
    );

    if (!output) return null;

    const countryCode = String(
      block.dataset.countryCode || ""
    ).trim().toUpperCase();

    const isFixedCountry =
      countryCode === "NL" || countryCode === "BE";

    const euMessage =
      block.dataset.euMessage ||
      "Ships within 1 working day - 3-5 working days delivery";

    const fallbackMessage =
      block.dataset.otherMessage ||
      "Delivery estimate available at checkout";

    let message = fallbackMessage;

    if (isFixedCountry) {
      message = euMessage;
    } else {
      const rawCutoff = Number(block.dataset.cutoff);

      const cutoff =
        Number.isInteger(rawCutoff) &&
        rawCutoff >= 0 &&
        rawCutoff <= 23
          ? rawCutoff
          : 22;

      try {
        message = calculateMessage(now, cutoff);
      } catch (error) {
        console.error(
          "[Custom Estimated Delivery] Error:",
          error
        );
      }
    }

    if (output.textContent.trim() !== message) {
      output.textContent = message;
    }

    return message;
  }

  function updateAll(root = document) {
    if (root.matches && root.matches(SELECTOR)) {
      updateBlock(root);
    }

    root.querySelectorAll(SELECTOR).forEach(function (block) {
      updateBlock(block);
    });
  }

  function init() {
    updateAll();

    // Update when the cutoff or day changes.
    if (!window.__estimatedDeliveryRefreshInterval) {
      window.__estimatedDeliveryRefreshInterval =
        window.setInterval(function () {
          updateAll();
        }, 30000);
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener(
      "DOMContentLoaded",
      init,
      { once: true }
    );
  } else {
    init();
  }

  document.addEventListener(
    "shopify:section:load",
    function (event) {
      updateAll(event.target);
    }
  );

  // Test helper for development.
  window.EstimatedDeliveryTest = function (
    isoDate,
    countryCode = "FR"
  ) {
    const sample = document.querySelector(SELECTOR);

    if (!sample) {
      return "Custom delivery block not found";
    }

    const testDate = new Date(isoDate);

    if (Number.isNaN(testDate.getTime())) {
      return "Invalid date";
    }

    const copy = sample.cloneNode(true);
    copy.dataset.countryCode =
      String(countryCode).trim().toUpperCase();

    const result = updateBlock(copy, testDate);

    console.log("Country:", countryCode);
    console.log("Message:", result);

    return result;
  };

  console.info("Custom Estimated Delivery loaded successfully");
})();
 